export default "__VITE_ASSET__Chq1HQN1__"